class UserDataService {
  constructor() {
  }

  setEmployee(employee) {
    this._employee = employee;
  }

  getEmployee() {
    return this._employee;
  }

  clean() {
    this._employee = undefined;
  }

  isEmpty() {
    return this._employee === undefined;
  }
}

export default UserDataService;



// WEBPACK FOOTER //
// ./client/app/common/services/userData.service.js